var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99961 9.49199C5.79961 9.49199 5.59961 9.39199 5.49961 9.29199L2.19961 5.99199C1.89961 5.69199 1.89961 5.19199 2.19961 4.89199C2.49961 4.59199 2.99961 4.59199 3.29961 4.89199L5.99961 7.59199L8.69961 4.89199C8.99961 4.59199 9.49961 4.59199 9.79961 4.89199C10.0996 5.19199 10.0996 5.69199 9.79961 5.99199L6.59961 9.19199C6.39961 9.39199 6.19961 9.49199 5.99961 9.49199Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switch_icon.f37201c10cf7832b51955808d538ef55.svg";
export { ForwardRef as ReactComponent };